import exceljs from "exceljs";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    getDatefromWeekNum, 
    outsideRoleCode, 
    mimeTypeMap, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function PMReport({ 
    filteredForms, 
    week, 
}){
    //no 2468, no 00000000, just remove all non billables.
    const user = useMyStore(state => state.user);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const handlePMReport = () => {
        setShowLoader(true);
        const mainData = filteredForms.map(raw => raw[week]);
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        for(let totalI = 0; totalI < 7; totalI++){
            const events = [];
            const worksheet = workbook.addWorksheet(getDatefromWeekNum(week, totalI));
            worksheet.state = "visible";
            worksheet.properties.defaultColWidth = 22.57;
            const headerArr = ["Name", "Region", "Bess Project"];
            const maxlength = Math.max(...mainData.map(person => person.data[totalI][0]?.billableJobNumber || 0));
            for(let jobii = 0; jobii < maxlength; jobii++){
                headerArr.push(`PM ${jobii + 1} Number`);
                headerArr.push(`PM ${jobii + 1} Regular`);
                headerArr.push(`PM ${jobii + 1} OT`);
                headerArr.push(`PM ${jobii + 1} Bill at Cost Regular`);
                headerArr.push(`PM ${jobii + 1} Bill at Cost OT`);
            }
            // headerArr.push(`Round up Bill at Cost Regular`);
            // headerArr.push(`Round up Bill at Cost OT`);
            const rows = [];
            for(let z = 0;  z < mainData.length; z++){
                const arr = [];
                arr.push(mainData[z].userName);
                arr.push(mainData[z].region ?? "Off Work");
                arr.push(outsideRoleCode[mainData[z].outside] ?? "");
                const jobs = mainData[z].data[totalI].slice(1).filter(job => job.nb < 1);
                for(const job of jobs){
                    //-------------------------
                    if(!job){
                        arr.push("");
                        arr.push("");
                        arr.push("");
                        arr.push("");
                        arr.push("");
                        continue;
                    }
                    //-------------------------
                    if(["Mob PGE", "DeMob PGE", "PGE PM Work", "PGE Field Meet"].includes(job.category)){
                        arr.push(job.pmNumber ?? "");
                        arr.push(job.bS === "0.00"?"":Number(job.bS));
                        arr.push(job.bO === "0.00"?"":Number(job.bO));
                        arr.push(job.bS2 === "0.00"?"":Number(job.bS2));
                        arr.push(job.bO2 === "0.00"?"":Number(job.bO2));
                    }else if(["Mob 3rd Party", "DeMob 3rd Party", "3rd Party Work", "3rd Party Field Meet", "Non Production"].includes(job.category)){
                        arr.push(job.division?.slice(0, 8).replace("_", "") ?? "");
                        arr.push(job.bS === "0.00"?"":Number(job.bS));
                        arr.push(job.bO === "0.00"?"":Number(job.bO));
                        arr.push(job.bS2 === "0.00"?"":Number(job.bS2));
                        arr.push(job.bO2 === "0.00"?"":Number(job.bO2));
                    }   
                }
                const bS3 = (mainData[z].data[totalI][0].bS3 && mainData[z].data[totalI][0].bS3 !== "0.00")?Number(mainData[z].data[totalI][0].bS3):0;
                const bO3 = (mainData[z].data[totalI][0].bO3 && mainData[z].data[totalI][0].bO3 !== "0.00")?Number(mainData[z].data[totalI][0].bO3):0;
                if(bS3 !== 0){
                    if(arr[arr.length - 2] === ""){
                        arr[arr.length - 2] = bS3;
                    }else{
                        arr[arr.length - 2] += bS3;
                    }
                }
                if(bO3 !== 0){
                    if(arr[arr.length - 1] === ""){
                        arr[arr.length - 1] = bO3;
                    }else{
                        arr[arr.length - 1] += bO3;
                    }
                }
                rows.push(arr);
            }
            //-------------------------------------------
            worksheet.addTable({
                name: `MyTable${totalI}`,
                ref: "A1",
                headerRow: true,
                style: {
                    theme: "TableStyleMedium9",
                    showRowStripes: true,
                },
                columns: headerArr.map(h => 
                    ({name: h,  filterButton: true})
                ),
                rows: rows,
            });
            events.forEach(e => {
                worksheet.getCell(...e).style = {
                    fill: {
                        type: "pattern", 
                        pattern:"solid", 
                        fgColor:{argb:"FFFF00"}
                    }
                }
            })
            //-------------------------------------------
            worksheet.columns.forEach(column => {
                const minLength = 18;
                let maxLength = 0;
                column["eachCell"]({ includeEmpty: true }, cell => {
                    const columnLength = cell.value?
                    cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.1)
                    :minLength;
                    if(columnLength > maxLength){
                        maxLength = columnLength;
                    }
                });
                column.width = maxLength < minLength ? minLength : maxLength;
            });
        }
        //-------------------------------------------
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), 
            `PM Report ${week}.xlsx`);
            setShowLoader(false);
        });
    }
    return(
        <span className = "pointer"
            onClick = {handlePMReport}
        >
            PM Report
        </span>
    )
}